/* eslint-disable object-shorthand */
import React, { useEffect, useRef, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import "./VagonStream.css";
import { isMobileSafari, isIOS } from "react-device-detect";
import { changeURLByRoomId, exitFullScreen, enterFullScreen, extractParamValue } from "../../utils/generalUtils";
import SpotifyInterface from "../spotify/components/SpotifyControls";
import * as constants from "../../constants";
import { sendEventsLog, Logout } from "../../api/UserController";
import { resumePlayer } from "../spotify/api/SpotifyController";
import { fetchVanityLinkData } from "../../api/VanityLinkController";
import { startInterval, stopInterval, alterState, sendVagonMessage } from "./helpers/utils";
import VanityFeatures from "./components/VanityFeatures";
import { setToSessionStorage, getFromSessionStorage } from "../../hooks/useSessionStorage";
import Igt from "../igt/Igt";
import LionGamingCasino from "../lionGaming/LionGamingCasino";
import ArcadeGame from "../arcadeGames/ArcadeGame";
import { getRoomSettingsById } from "../../api/RoomsController";
import CasinoLight from "../casinoLight/CasinoLight";
import Streaming from "../streaming/Streaming";
import Guestbook from "../guestbook/Guestbook";
import SpotifyControls from "../spotify/components/SpotifyControlsV2";
import { socket, sendSocketMessage } from "../../socket";
import Hallway from "../hallway/Hallway";
import ExitIntraverseModal from "./components/ExitIntraverseModal";
import SmallIframeModal from "../iFrameSmallModal/SmallIframeModal";
import AvatarPresetPage from "../../pages/presets/AvatarPresetPage";

const VagonStreamIntraverse = (props) => {
    const dispatch = useDispatch();
    const userId = useSelector((state) => state?.user?.userId);
    const teddySwimRoomId = "992ee1dc-474b-46ed-9788-3b35739880f5";
    const netcoinsRoomId = "09263309-11ad-40e9-b0df-a60711f5028c";
    const elementRef = useRef(null);
    const intervalIdRef = useRef(null);
    const spotifyPlaying = useRef(false);

    // Use state for netcoins prop to trigger Hallway reloads
    const [netcoinsProp, setNetcoinsProp] = useState(getFromSessionStorage("netcoins") === "true");

    const [vanityLinkInfo, setVanityLinkInfo] = useState(JSON.parse(localStorage.getItem("vanityLinkInfo")) || {});
    const [roomSettings, setRoomSettings] = useState(JSON.parse(localStorage.getItem("roomSettings")) || {});

    const [showCornerButtons, setShowCornerButtons] = useState(true);
    const [landscape, setLandscape] = useState(false);
    const [fullScreen, setFullScreen] = useState(JSON.parse(getFromSessionStorage("fullscreen") || "false"));
    const [openBroadcastModal, setOpenBroadcastModal] = useState(false);
    const [playingMusic, setPlayingMusic] = useState(false);
    const [openSpotify, setOpenSpotify] = useState(false);

    const [isStreaming, setIsStreaming] = useState(false);
    const [igtSlot, setIgtSlot] = useState(null);
    const [lionGamingSlot, setLionGamingSlot] = useState(null);
    const [casinoLightSlot, setCasinoLightSlot] = useState(null);
    const [arcadeGameOpen, setArcadeGameOpen] = useState(false);
    const [avatarOpen, setIsAvatarOpen] = useState(false);
    const [avatarEditing, setAvatarEditing] = useState(false);
    const [updatedAvatarUrlSet, setUpdatedAvatarUrlSet] = useState(false);
    const [hallwayPrompt, setHallwayPrompt] = useState("");
    const [isSmallModalOpen, setIsSmallModalOpen] = useState(false);
    const [smallIframeUrl, setSmallIframeUrl] = useState(
        ""
        // "OPEN_SMALL_IFRAME, https://storage.googleapis.com/amadea_static/TyBigImages/TerraZero-One-Sheet_Intraverse.pdf, fullscreen"
        // "OPEN_SMALL_IFRAME, https://open.spotify.com/embed/album/2Ui10TWQIabivg41HaHP41?utm_source=generator"
    );
    // These features are WIP, need to be made dynamically configurable
    const [teddyNoteOpen, setTeddyNoteOpen] = useState(false);
    const [openTeddySelfiePopup, setOpenTeddySelfiePopup] = useState(false);
    const [openContestModalState, setOpenContestModalState] = useState(false);
    const [isInputFocused, setIsInputFocused] = useState(false);
    const [isHallwayOpen, setIsHallwayOpen] = useState(true);

    const [dynamicLinkOutUrl, setDynamicLinkOutUrl] = useState("");
    const [openLinkoutExitModal, setOpenLinkoutExitModal] = useState(false);

    // const handleFocusChange = (isFocused) => {
    //     setIsInputFocused(isFocused);
    //     console.log(`Input focused: ${isFocused}`);
    // };
    const [isGuestbookOpen, setIsGuestbookOpen] = useState(false);
    const [selectedAvatar, setSelectedAvatar] = useState(getFromSessionStorage("selectedAvatar"));

    useEffect(() => {
        const storedRoomSettings = JSON.parse(sessionStorage.getItem("roomSettings"));
        if (storedRoomSettings) {
            console.log("Restoring Room Settings from localStorage:", storedRoomSettings);
            setRoomSettings(storedRoomSettings);
        }
    }, []);

    useEffect(() => {
        socket.connect();

        socket.on("connect", () => {
            console.log("Connected to server", socket.id);
        });

        socket.on("system_message", async (response) => {
            try {
                if (typeof response === "string" && response.includes("$type")) {
                    const arr = JSON.parse(response);
                    if (Array.isArray(arr) && typeof arr[0] === "string") {
                        const parsedResponse = JSON.parse(arr[0]);
                        const receivedUser = parsedResponse.UserId;
                        if (parsedResponse.$type === "8" && receivedUser === userId) {
                            if (parsedResponse.Url && !parsedResponse.Url.includes("intraverse.com")) {
                                setDynamicLinkOutUrl(parsedResponse.Url);
                                setOpenLinkoutExitModal(true);
                            } else {
                                window.open(parsedResponse.Url, "_blank");
                            }
                        }
                    }
                }
            } catch (error) {
                console.error("Error processing system message:", error);
            }
        });

        socket.on("broadcastAction", (data) => {
            console.log("Received broadcast action:", data);
            if (typeof data === "object" && data?.action === constants.OPEN_VIDEO_BROADCAST) {
                setIsStreaming(true);
            } else if (typeof data === "object" && data?.action === constants.END_VIDEO_BROADCAST) {
                setIsStreaming(false);
            }
        });

        return () => {
            // socket.disconnect();
        };
    }, []);

    const setVanityLinkData = async (roomId) => {
        const vanityLink = await changeURLByRoomId(roomId);
        if (vanityLink) {
            const { data } = await fetchVanityLinkData(vanityLink);
            setVanityLinkInfo((value) => ({ ...value, ...data }));
            localStorage.setItem("vanityLinkInfo", JSON.stringify(data));
        }
    };

    const setVanityRoomSettings = async (roomId) => {
        const { data } = await getRoomSettingsById(roomId);

        if (data) {
            setRoomSettings((prevSettings) => {
                const newSettings = { ...prevSettings, ...data };
                localStorage.setItem("roomSettings", JSON.stringify(newSettings));
                return newSettings;
            });

            // if (data?.spotifyTrack) {
            //     startSpotifyPlayer(data?.spotifyTrack);
            // }
        }
    };

    const setIgtSlotData = async (data) => {
        setIgtSlot(data);
    };

    const setLionGamingSlotData = async (data) => {
        setLionGamingSlot(data);
    };
    const setCasinoLightSlotData = async (data) => {
        console.log("Casino Light Slot Data:", data);
        setCasinoLightSlot(data);
    };

    const removeVanityLinkData = () => {
        if (spotifyPlaying.current) {
            props.spotifyPlayer?.pause();
            alterState(setPlayingMusic);
            spotifyPlaying.current = false;
        }
        localStorage.setItem("vanityLinkInfo", null);
        localStorage.setItem("roomSettings", null);
        setVanityLinkInfo({});
        setRoomSettings({});
        setOpenSpotify(false);
    };

    const startSpotifyPlayer = useCallback(async (track) => {
        const type = constants.ALBUM;
        const spotifyToken = getFromSessionStorage("spotifyAccessToken");
        if (spotifyToken) {
            try {
                spotifyPlaying.current = true;
                const result = await resumePlayer(spotifyToken, track, type);
                if (result === 200) {
                    alterState(setPlayingMusic);
                }
            } catch {
                spotifyPlaying.current = false;
            }
        }
        setIsStreaming(false);
    }, []);

    const messageActions = {
        [constants.OPEN_BROADCAST_MODAL]: () => {
            sendVagonMessage(constants.UNITY_OPEN_WEB_INTERFACE);
            alterState(setOpenBroadcastModal);
        },
        [constants.OPEN_VIDEO_BROADCAST]: () => {
            alterState(setIsStreaming);
        },
        [constants.END_VIDEO_BROADCAST]: () => {
            alterState(setIsStreaming);
        },
        [constants.OPEN_TEDDY_SELFIE]: () => alterState(setOpenTeddySelfiePopup),
        [constants.OPEN_SPOTIFY]: () => {
            alterState(setOpenSpotify);
        },
        [constants.CLOSE_SPOTIFY]: () => alterState(setOpenSpotify),
        [constants.PDF_OPEN]: () => alterState(setShowCornerButtons),
        [constants.PDF_CLOSE]: () => alterState(setShowCornerButtons),
        [constants.OPEN_TEDDY_CONTEST]: () => {
            sendVagonMessage(constants.UNITY_OPEN_WEB_INTERFACE);
            alterState(setOpenContestModalState);
        },
        [constants.OPEN_TEDDY_NOTE]: () => {
            sendVagonMessage(constants.UNITY_OPEN_WEB_INTERFACE);
            alterState(setTeddyNoteOpen);
        },
        [constants.FULL_SCREEN]: () => {
            alterState(setFullScreen);
        },
        [constants.SETUPCARD]: () => {
            window.open("/wallet?source=web_unity");
        },
        [constants.PAUSE_BACKGROUND_MUSIC]: () => {
            const audio = document.getElementById("audio");
            audio.pause();
        },
        [constants.PLAY_BACKGROUND_MUSIC]: () => {
            const audio = document.getElementById("audio");
            audio.play();
        },
        [constants.ENTERING_NAV_MENU]: () => {
            const audio = document.getElementById("audio");
            audio.stop();
        },
    };

    // This function is called when the script is loaded, it is used to listen to the messages sent from the application
    // States can not be updated within the function, so we are using alterState function to update the state
    const loadedScript = () => {
        startInterval(intervalIdRef);

        window.Vagon.onConnected(() => {
            setTimeout(() => {
                const audio = document.getElementById("audio");
                audio.pause();
            }, 12000);
        });

        window.Vagon.onApplicationMessage(async (evt) => {
            const message = evt.message.toString();
            console.log("Vagon message: ", message);

            if (messageActions[message]) {
                messageActions[message]();
            } else if (message.includes(constants.ROOM_UNLOADED)) {
                removeVanityLinkData();
            } else if (message.includes(constants.NEW_ROOM_LOADING)) {
                const roomId = message.split(":");
                if (roomId[1]) {
                    setVanityLinkData(roomId[1]);
                    setVanityRoomSettings(roomId[1]);
                    if (roomId[1] === netcoinsRoomId) {
                        console.log("Netcoins Room Detected:", roomId[1]);
                        setNetcoinsProp(true);
                        setToSessionStorage("netcoins", "true");
                    } else {
                        setNetcoinsProp(false);
                        setToSessionStorage("netcoins", "false");
                    }
                }
            }
            if (message.includes(constants.SLOT)) {
                setIgtSlotData(message);
            } else if (message.includes(constants.LIONGAME)) {
                setLionGamingSlotData(message);
            } else if (message.includes(constants.CASINOLIGHT)) {
                setCasinoLightSlotData(message);
            } else if (message.includes(constants.OPEN_ARCADE_GAME)) {
                setArcadeGameOpen(true);
            } else if (message.includes(constants.LOGOUT)) {
                await Logout(dispatch);
            } else if (message.includes(constants.OPEN_GUESTBOOK)) {
                setIsGuestbookOpen(true);
            } else if (message.includes(constants.EDIT_RPM_AVATAR)) {
                setIsAvatarOpen(true);
                setAvatarEditing(true);
                setUpdatedAvatarUrlSet(false);
                setHallwayPrompt("I'm editing my avatar now");
            } else if (message.includes(constants.OPEN_SMALL_IFRAME)) {
                setSmallIframeUrl(message);
                console.log("Small Iframe URL set:", message);
                setIsSmallModalOpen(true);
            } else if (message.includes(constants.OPEN_HALLWAY)) {
                setIsHallwayOpen(true);
                setHallwayPrompt("Hello!");
            }
            const paramStart = message.indexOf("&clientSessionId=");
            if (paramStart !== -1) {
                const clientSessionId = extractParamValue(message, "clientSessionId");
                const userToken = extractParamValue(message, "token");
                const envunity = extractParamValue(message, "envunity");
                const userId = extractParamValue(message, "displayName");

                if (clientSessionId !== null && userToken !== null && envunity !== null && userId !== null) {
                    setToSessionStorage("clientSessionId", clientSessionId);
                    setToSessionStorage("envUnity", envunity);
                    await sendEventsLog(
                        userToken,
                        "",
                        userId,
                        constants.LOG_EVENTS_LISTENER_DATA,
                        "info",
                        { generatedSlotUrl: window.location.href, message },
                        clientSessionId,
                        envunity
                    );
                }
            }
        });
    };

    useEffect(() => {
        if (!avatarEditing) {
            setHallwayPrompt("I'm really loving my new avatar now! I look great!");
        }
    }, [avatarEditing]);

    const updateOrientation = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        const aspectRatio = width / height;
        const iframeElement = document.getElementById("vagonFrame");

        // second check to ensure aspect Ratio is below 1
        if (aspectRatio < 1) {
            iframeElement.classList.add("force-landscape");
            iframeElement.style.removeProperty("width");
            iframeElement.style.removeProperty("height");
            setLandscape(true);
        } else {
            iframeElement.classList.remove("force-landscape");
            iframeElement.style.width = "100vw";
            iframeElement.style.height = "100vh";
            setLandscape(false);
        }
        if (isIOS) iframeElement.style.padding = "10px";
    };

    useEffect(() => {
        if (fullScreen === true || fullScreen === "true") {
            enterFullScreen(elementRef);
            console.log("ref", elementRef.current);
        } else if (
            (document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullScreenElement) &&
            !fullScreen
        ) {
            setToSessionStorage("fullscreen", false);
            exitFullScreen();
        }
        updateOrientation();
    }, [fullScreen]);

    useEffect(() => {
        const head = document.querySelector("head");
        const script = document.createElement("script");
        script.setAttribute("src", "https://app.vagon.io/vagonsdk.js");

        script.addEventListener("load", () => {
            loadedScript();
        });
        head.appendChild(script);
        window.addEventListener("resize", updateOrientation);

        return () => {
            stopInterval(intervalIdRef);
            window.removeEventListener("resize", updateOrientation);
            script.removeEventListener("load", loadedScript);
        };
    }, []);

    useEffect(() => {
        if (
            openBroadcastModal ||
            teddyNoteOpen ||
            openContestModalState ||
            openTeddySelfiePopup ||
            isInputFocused ||
            isGuestbookOpen ||
            avatarOpen ||
            openLinkoutExitModal ||
            arcadeGameOpen
        ) {
            stopInterval(intervalIdRef);
            window.Vagon.keepAlive();
        } else {
            startInterval(intervalIdRef);
        }
    }, [
        openBroadcastModal,
        teddyNoteOpen,
        openContestModalState,
        openTeddySelfiePopup,
        isInputFocused,
        isGuestbookOpen,
        avatarOpen,
        openLinkoutExitModal,
        arcadeGameOpen,
    ]);

    return (
        <div
            ref={elementRef}
            className="iframe-container"
            style={{
                width: landscape ? "null" : "100%",
                height: "100vh",
                background: "black",
                zIndex: 100,
                overflow: "hidden",
                position: "relative",
            }}
        >
            {igtSlot && <Igt data={igtSlot} setIgtSlot={setIgtSlot} />}
            {lionGamingSlot && <LionGamingCasino data={lionGamingSlot} setLionGamingSlot={setLionGamingSlot} />}
            {arcadeGameOpen && <ArcadeGame onClose={() => setArcadeGameOpen(false)} />}
            {avatarOpen && (
                // <AvatarEditModal
                //     source="editAvatarModal"
                //     userId={userId}
                //     avatarEditing={avatarEditing}
                //     setAvatarEditing={setAvatarEditing}
                //     onRpmClose={() => {
                //         setAvatarEditing(false);
                //     }}
                //     updatedAvatarUrlSet={updatedAvatarUrlSet}
                //     setUpdatedAvatarUrlSet={setUpdatedAvatarUrlSet}
                // />
                <AvatarPresetPage
                    setSelectedAvatar={setSelectedAvatar}
                    selectedAvatar={selectedAvatar}
                    forceLandScape
                    userId={userId}
                    source="editAvatarModal"
                    setIsAvatarOpen={setIsAvatarOpen}
                />
            )}
            {casinoLightSlot && <CasinoLight data={casinoLightSlot} setCasinoLightSlot={setCasinoLightSlot} />}
            {isStreaming && (
                <Streaming streamId={roomSettings?.broadcastId} roomId={roomSettings?.roomId} userId={userId} />
            )}
            {isGuestbookOpen && <Guestbook onClose={() => setIsGuestbookOpen(false)} />}
            {openLinkoutExitModal && (
                <ExitIntraverseModal onClose={() => setOpenLinkoutExitModal(false)} url={dynamicLinkOutUrl} />
            )}

            <VanityFeatures
                fullScreen={fullScreen}
                setFullScreen={setFullScreen}
                vanityLinkInfo={vanityLinkInfo}
                openBroadcastModal={openBroadcastModal}
                setOpenBroadcastModal={setOpenBroadcastModal}
                showCornerButtons={showCornerButtons}
                landscape={landscape}
            />

            {roomSettings?.roomId === teddySwimRoomId ? (
                <SpotifyInterface
                    player={props?.spotifyPlayer}
                    setFullScreen={setFullScreen}
                    landscape={landscape}
                    teddyNoteOpen={teddyNoteOpen}
                    setTeddyNoteOpen={setTeddyNoteOpen}
                    openTeddySelfiePopup={openTeddySelfiePopup}
                    setOpenTeddySelfiePopup={setOpenTeddySelfiePopup}
                    playingMusic={playingMusic}
                    openContestModalState={openContestModalState}
                    setOpenContestModalState={setOpenContestModalState}
                    openSpotify={openSpotify}
                    setOpenSpotify={setOpenSpotify}
                    spotifyTrack={roomSettings?.spotifyTrack || null}
                    startSpotifyPlayer={startSpotifyPlayer}
                />
            ) : (
                <SpotifyControls
                    setOpenSpotify={setOpenSpotify}
                    openSpotify={openSpotify}
                    player={props?.spotifyPlayer}
                />
            )}

            <Hallway
                location="inGame"
                setIsHallwayOpen={setIsHallwayOpen}
                isHallwayOpen={isHallwayOpen}
                hallwayPrompt={hallwayPrompt}
                netcoins={netcoinsProp}
            />
            {isSmallModalOpen && (
                <SmallIframeModal
                    setIsSmallModalOpen={setIsSmallModalOpen}
                    smallIframeUrl={smallIframeUrl}
                    isSmallModalOpen={isSmallModalOpen}
                    setSmallIframeUrl={setSmallIframeUrl}
                    setOpenSpotify={setOpenSpotify}
                />
            )}
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    position: "relative",
                }}
            >
                <iframe
                    id="vagonFrame"
                    title="Vagon Stream Content"
                    allow="microphone *; clipboard-read *; clipboard-write *; encrypted-media *;"
                    style={{
                        width: "100vw",
                        height: isIOS && isMobileSafari ? "85vh" : "100vh",
                        border: 0,
                        zIndex: 100,
                        overflow: "hidden",
                    }}
                    src={props.streamUrl}
                    sandbox="allow-pointer-lock allow-scripts allow-forms allow-same-origin allow-popups"
                />
            </div>
        </div>
    );
};

VagonStreamIntraverse.propTypes = {
    streamUrl: PropTypes.string.isRequired,
    spotifyPlayer: PropTypes.object,
};

export default VagonStreamIntraverse;
